module.exports = __webpack_public_path__ + "img/UnlockIcon.995d81c9.svg";